import React, { useState } from "react"
import ReactTooltip from "react-tooltip"
import notFound from "@/assets/img/not-found.png"
import { trans } from "@/_providers/Translation"
import { Tooltip } from "@mui/material"

function Table(props) {
  // quantity chosen per row, keyed by part number
  const [quantities, setQuantities] = useState({})

  const getQty = (number) => {
    let qty = quantities[number]
    return qty === undefined || qty === "" ? 1 : qty
  }

  const handleQtyChange = (number, value) => {
    let qty = Math.max(1, parseInt(value, 10) || 1)
    setQuantities((prev) => ({ ...prev, [number]: qty }))
  }

  if (props.parts.length === 0) {
    return (
      <div className="not-found">
        <img src={notFound} alt="Not Found" />
        <p>{trans("catalogue.noResults")}</p>
      </div>
    )
  }

  return (
    <div className="table-scroller">
      <table>
        <thead>
          <tr>
            <th style={{ minWidth: "130px" }}>
              {trans("catalogue.addToCart")}
            </th>
            <th>{trans("catalogue.thumbnail")}</th>
            <th>{trans("catalogue.number")}</th>
            <th>{trans("catalogue.name")}</th>
            <th>{trans("catalogue.originalNumber")}</th>
            <th>{trans("catalogue.brand")}</th>
            <th>{trans("catalogue.group")}</th>
            <th className="right">{trans("catalogue.price")}</th>
            <th className="right">{trans("catalogue.salePrice")}</th>
            <th>{trans("catalogue.priceTiers")}</th>
            <th className="center">{trans("catalogue.availability")}</th>
            <th>{trans("catalogue.delivery")}</th>
          </tr>
        </thead>
        <tbody>
          {props.parts.map((p, i) => {
            let number = p.number
            let inStock = Number(p.quantity) > 0

            return (
              <tr key={"part-" + number + "-" + i}>
                <td>
                  <div className="add-to-cart-cell">
                    <input
                      type="number"
                      min="1"
                      value={getQty(number)}
                      onChange={(e) => handleQtyChange(number, e.target.value)}
                    />
                    <button
                      type="button"
                      className="button-add-cart"
                      title={trans("catalogue.addToCart")}
                      disabled={props.addingNumber === number}
                      onClick={() =>
                        props.handleAddToCart(number, getQty(number))
                      }
                    >
                      {props.addingNumber === number ? (
                        <span className="cart-spinner" />
                      ) : (
                        <svg
                          viewBox="0 0 24 24"
                          width="18"
                          height="18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 3h2.2l1.2 12.2a2 2 0 0 0 2 1.8h8.9a2 2 0 0 0 2-1.6L20.5 8H6"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <circle cx="9" cy="20" r="1.4" fill="currentColor" />
                          <circle cx="17" cy="20" r="1.4" fill="currentColor" />
                        </svg>
                      )}
                    </button>
                  </div>
                </td>
                <td>
                  {p.thumbnail ? (
                    <img
                      data-tip
                      data-for={"img-" + p?.number}
                      src={p.thumbnail}
                      alt=""
                      height={25}
                    />
                  ) : (
                    "-"
                  )}

                  <ReactTooltip
                    id={"img-" + p?.number}
                    effect="solid"
                    border={true}
                    borderColor="#ccc"
                    backgroundColor="white"
                    arrowColor="white"
                  >
                    <img
                      src={p.thumbnail}
                      alt=""
                      style={{ maxWidth: "300px", maxHeight: "300px" }}
                    />
                  </ReactTooltip>
                </td>
                <td>{number}</td>
                <td>{p.name}</td>
                <td>{(p.original_number || "").trim() || "-"}</td>
                <td>{p.brand}</td>
                <td>{(p.group || "").trim() || "-"}</td>
                <td className="right">{Number(p.price).toFixed(2)}</td>
                <td className="right">{Number(p.sale_price).toFixed(2)}</td>
                <td>
                  {Array.isArray(p.prices) && p.prices.length ? (
                    <>
                      <Tooltip
                        // id={'tiers-' + number + '-' + i}
                        // effect="solid"
                        // backgroundColor="#586a82"
                        // textColor="#262f5f"
                        // border={true}
                        followCursor
                        title={
                          <ul className="price-tiers">
                            {p.prices.map((tier, ti) => (
                              <li key={"tier-" + ti}>
                                <span>
                                  {trans("catalogue.fromQty", {
                                    qty: tier.quantity,
                                  })}
                                </span>
                                <span>{Number(tier.price).toFixed(2)}</span>
                              </li>
                            ))}
                          </ul>
                        }
                      >
                        <span
                          className="volume-pricing-info"
                          data-tip
                          data-for={"tiers-" + number + "-" + i}
                        >
                          <svg
                            viewBox="0 0 24 24"
                            width="16"
                            height="16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="9"
                              stroke="currentColor"
                              strokeWidth="1.8"
                            />
                            <path
                              d="M12 11v5"
                              stroke="currentColor"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                            />
                            <circle cx="12" cy="8" r="1" fill="currentColor" />
                          </svg>
                          {trans("catalogue.volumePricing")}
                        </span>
                      </Tooltip>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td className="center">
                  <span
                    className={[
                      "badge",
                      inStock ? "in-stock" : "out-of-stock",
                    ].join(" ")}
                  >
                    {inStock
                      ? `${trans("catalogue.inStock")} (${p.quantity})`
                      : trans("catalogue.outOfStock")}
                  </span>
                  {p.equivalent_available ? (
                    <div style={{ fontSize: "11px", marginTop: "4px" }}>
                      {trans("catalogue.equivalentAvailable")}
                    </div>
                  ) : (
                    ""
                  )}
                </td>
                <td>
                  {Number(p.delivery_time_days) > 0
                    ? `${p.delivery_time_days} ${trans("catalogue.days")}`
                    : p.can_be_ordererd
                      ? trans("catalogue.canOrder")
                      : "-"}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default Table
